import { isWeb, tva } from "@gluestack-ui/utils/nativewind-utils";

const captionTableStyle = isWeb ? "caption-bottom" : "";

export const tableStyle = tva({
  base: `table border-separate border-spacing-0 overflow-hidden`,
  variants: {
    variant: {
      bordered: "w-[800px]",
      plain: "w-full",
    },
  },
  defaultVariants: {
    variant: "bordered",
  },
});

export const tableHeaderStyle = tva({
  base: "",
});

export const tableBodyStyle = tva({
  base: "",
});

export const tableFooterStyle = tva({
  base: "",
});

export const tableHeadStyle = tva({
  base: "sticky top-0 z-10",
  variants: {
    variant: {
      bordered:
        "border-t border-b border-outline-200 border-solid first:rounded-tl-2xl last:rounded-tr-2xl last:border-r first:border-l bg-background-50",
      plain:
        "border-b first:rounded-tl-2xl last:rounded-tr-2xl bg-background-0",
    },
    size: {
      sm: "p-2",
      md: "p-3",
      lg: "p-5",
      xl: "p-8",
    },
  },
  defaultVariants: {
    variant: "bordered",
  },
});

export const tableRowStyleStyle = tva({
  base: "border-0",
  variants: {
    variant: {
      bordered: "",
      plain: "hover:bg-background-50",
    },
    isHeaderRow: {
      true: "",
    },
    isFooterRow: {
      true: "",
    },
  },
  defaultVariants: {
    variant: "bordered",
  },
});

export const tableDataStyle = tva({
  base: "flex-1 overflow-hidden bg-background-0",
  variants: {
    variant: {
      bordered:
        "border-b border-outline-200 border-solid first:border-l last:border-r",
      plain: "border-b border-outline-100 border-solid",
    },
    size: {
      sm: "px-2 py-1",
      md: "px-3 py-2",
      lg: "px-5 py-4",
      xl: "px-7 py-6",
    },
    isLastRow: {
      true: "first:rounded-bl-2xl last:rounded-br-2xl",
    },
    isSelected: {
      true: "bg-brand-50",
    },
  },
  defaultVariants: {
    variant: "bordered",
  },
});

export const tableCaptionStyle = tva({
  base: `${captionTableStyle} px-6 py-[14px] text-[16px] font-normal text-typography-800 bg-background-50 font-roboto`,
});
